import React, { Component } from "react";
import { Link } from "react-router-dom";

// Components
import Icon from "../../components/Icon";

// Helper
import { login, saveSession, isLoggedIn } from "../../Helper/Api";
import Toast from "../../components/Toast/Toast";
import { t } from "../../Helper/i18n";

const properties = require("../../properties.json");

// Just the form. The ground, the halo, the sheet, the white half and the tabs
// belong to pages/Auth/AuthLayout.js, which stays mounted while this swaps
// with SignUp -- so moving between the two no longer rebuilds the screen.
// The tenant is resolved once by the layout and arrives as a prop.
class SignIn extends Component {
  state = {
    email: "",
    password: "",
    buttonText: t("login"),
    submitting: false,
    msg: null,
    // design-only: whether to show the password, and whether the last attempt
    // was rejected (both fields are marked, because the server does not say
    // which one was wrong)
    showPass: false,
    bad: false,
  };

  componentDidMount() {
    document.title = properties.site_name + " - " + t("login");

    if (isLoggedIn()) {
      window.location.href = "/";
    }
  }

  submit = (e) => {
    e.preventDefault();
    const { email, password } = this.state;
    if (!email || !password) {
      this.setState({ msg: { text: t("enterEmailPass"), type: "warning" }, bad: true });
      return;
    }

    this.setState({ submitting: true, buttonText: t("signingIn"), msg: null, bad: false });

    login(email, password)
      .then((user) => {
        saveSession(user.token, user);
        this.setState({ msg: { text: t("signedIn"), type: "success" } });
        setTimeout(() => {
          window.location.href = "/";
        }, 800);
      })
      .catch((error) => {
        this.setState({
          submitting: false,
          buttonText: t("login"),
          msg: { text: error.message || t("badLogin"), type: "warning" },
          bad: true,
        });
      });
  };

  render() {
    const { buttonText, submitting, msg, showPass, bad } = this.state;

    return (
      <div className="au-swap">
        <div className="au-head">
          <h1>{t("signInTitle")}</h1>
          <p>{t("signInLead")}</p>
        </div>

        <form className="au-form" onSubmit={this.submit}>
          <div className="au-field" style={{ "--d": "120ms" }}>
            <label className="lb" htmlFor="email">{t("email")}</label>
            <div className={`au-box ${bad ? "is-bad" : ""}`}>
              <span className="ic" aria-hidden="true"><Icon name="mail" /></span>
              <input
                type="text"
                id="email"
                autoComplete="username"
                placeholder="name@example.com"
                value={this.state.email}
                onChange={(e) => this.setState({ email: e.target.value })}
              />
            </div>
          </div>

          <div className="au-field" style={{ "--d": "200ms" }}>
            <label className="lb" htmlFor="pass-code">{t("password")}</label>
            <div className={`au-box ${bad ? "is-bad" : ""}`}>
              <span className="ic" aria-hidden="true"><Icon name="lock" /></span>
              <input
                type={showPass ? "text" : "password"}
                id="pass-code"
                autoComplete="current-password"
                placeholder="••••••••"
                value={this.state.password}
                onChange={(e) => this.setState({ password: e.target.value })}
              />
              <button
                type="button"
                className="au-reveal"
                onClick={() => this.setState({ showPass: !showPass })}
                aria-label={showPass ? t("hidePass") : t("showPass")}
              >
                <Icon name={showPass ? "eyeoff" : "eye"} />
              </button>
            </div>
          </div>

          <button className="mu-btn is-gold au-submit" type="submit" disabled={submitting}>
            {submitting && <span className="spin" aria-hidden="true"></span>}
            {buttonText}
          </button>

          <Toast msg={msg} />

          {/* the tabs above already move between the two auth pages, so this
              slot carries the way back to the site instead */}
          <Link to="/" className="au-home">
            <Icon name="arrow" aria-hidden="true" />
            {t("backToSite")}
          </Link>
        </form>
      </div>
    );
  }
}

export default SignIn;
